exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n\r\n.layout-wrapper .layout-sidebar .layout-menu>li.active-menuitem>ul {\r\n    background-color: #535F6A;\r\n    border-bottom-left-radius: 6px;\r\n    border-bottom-right-radius: 6px;\r\n    height: auto;\r\n}\r\n\r\n.layout-wrapper .layout-sidebar .layout-menu li ul {\r\n    height: 0px;\r\n    overflow: hidden;\r\n    list-style-type: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/adri9/Escritorio/admin-everpath/src/app/app.submenu.css
// module id = ../../../../../src/app/app.submenu.css
// module chunks = main